import {
  Box,
  Fade,
  Button,
  Typography,
  Checkbox,
  Snackbar,
  Alert,
  TextField,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Calendar, Loading } from "../../common/components";
import dayjs from "dayjs";
import { getAsistencias, putAsistencia } from "../../helpers/ceremonias";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

export const Asistencias = () => {
  //Nombre de la pestaña
  document.title = "Asistencias";
  const [loading, setLoading] = useState(true);
  const [loadingText, setLoadingText] = useState("Obteniendo asistencias");
  const [startDate, setStartDate] = useState({
    fecha: null,
  });
  const [endDate, setEndDate] = useState({
    fecha: null,
  });

  const [rows, setRows] = useState([]);

  const [showAlert, setShowAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(
    "Error: No se puedo actualizar la información."
  );

  const columns = [
    { field: "dia", headerName: "Día", width: 130 },
    { field: "horario", headerName: "Hora", width: 110 },
    {
      field: "puesto",
      headerName: "Puesto",
      width: 100,
    },
    {
      field: "nombre_completo",
      headerName: "Acólito",
      width: 350,
    },
    {
      field: "asistencia",
      headerName: "Asistencia",
      width: 130,
      //Permitir que puedan marcarse los checkbox y no dejar escribir letras
      editable: true,
      type: "boolean",
      renderCell: (params) => {
        return (
          <Checkbox
            checked={params.value === 1} // Convertimos 1 a true y 0 a false
            color="primary"
            inputProps={{ "aria-label": "primary checkbox" }}
            //Pintar en verde si está marcado
            style={{ color: params.value === 1 ? "green" : "red" }}
            onChange={(event) => {
              params.api.updateRows([
                { ...params.row, asistencia: event.target.checked ? 1 : 0 },
              ]);

              setLoadingText("Actualizando asistencia");
              setLoading(true);
              updateAsistencia(params, params.id, event.target.checked ? 1 : 0);
            }}
          />
        );
      },
      renderEditCell: (params) => {
        return (
          <Tooltip title="Marcar asistencia">
            <Checkbox
              id="asistencia"
              checked={params.value === 1} // Convertimos 1 a true y 0 a false
              color="primary"
              onChange={(event) => {
                params.api.setEditCellValue({
                  id: params.id,
                  field: "asistencia",
                  value: event.target.checked ? 1 : 0,
                });

                setLoadingText("Actualizando asistencia");
                setLoading(true);
                updateAsistencia(
                  params,
                  params.id,
                  event.target.checked ? 1 : 0
                );
              }}
              inputProps={{ "aria-label": "primary checkbox" }}
              //Pintar en verde si está marcado
              style={{ color: params.value === 1 ? "green" : "red" }}
            />
          </Tooltip>
        );
      },
    },

    {
      field: "observaciones",
      headerName: "Observaciones",
      width: 600,

      editable: true,
      renderEditCell: (params) => {
        return (
          <TextField
            autoFocus
            fullWidth
            multiline
            variant="outlined"
            sx={{
              // Cambiar el tamaño de la letra
              "& .MuiInputBase-input": {
                fontSize: 13,
              },
            }}
            type="text"
            value={params.value}
            onChange={(event) => {
              params.api.setEditCellValue({
                id: params.id,
                field: "observaciones",
                value: event.target.value,
              });
            }}
            //Envíar la petición al servidor cuando se presione enter o se salga del input
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                setLoadingText("Actualizando observaciones");
                setLoading(true);
                updateObservaciones(params, params.id, event.target.value);
              }
            }}
            //Enviar la petición al servidor cuando se salga del input
            onBlur={() => {
              setLoadingText("Actualizando observaciones");
              setLoading(true);
              updateObservaciones(params, params.id, params.value);
            }}
          />
        );
      },
    },
  ];

  const updateAsistencia = async (params, id, asistencia) => {
    const resp = await putAsistencia({
      id: id,
      asistencia: asistencia,
    });
    //Si el status es 200, se actualizó correctamente
    if (resp.status !== 200) {
      console.log("Error al actualizar asistencia", resp);
      setShowAlert(true);

      console.log("Error al actualizar asistencia");
      //Cambiar el valor del checkbox
      params.api.setEditCellValue({
        id: params.id,
        field: "asistencia",
        value: asistencia === 1 ? 0 : 1,
      });
    }
    setLoading(false);
  };

  const updateObservaciones = async (params, id, observaciones) => {
    const resp = await putAsistencia({
      id: id,
      observaciones: observaciones,
    });
    //Si el status es 200, se actualizó correctamente
    if (resp.status !== 200) {
      setShowAlert(true);

      console.log("Error al actualizar observaciones");
      //Cambiar el valor del checkbox
      params.api.setEditCellValue({
        id: params.id,
        field: "observaciones",
        value: observaciones,
      });
    }
    setLoading(false);
  };

  const getData = async () => {
    setLoading(true);
    const today = dayjs();
    let stDate = startDate.fecha;
    let edDate = endDate.fecha;

    if (startDate.fecha == null || startDate.fecha == "") {
      stDate = today.subtract(1, "week").day(0).format("YYYY-MM-DD");

      setStartDate({
        fecha: stDate,
      });
    }

    if (endDate.fecha == null || endDate.fecha == "") {
      // Fecha de hoy
      edDate = today.format("YYYY-MM-DD");
      setEndDate({
        fecha: edDate,
      });
    }

    getAsistencias(stDate, edDate).then((ceremonias) => {
      setRows(ceremonias);

      setLoading(false);
    });
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Fade in={true} timeout={1000}>
        <div>
          {loading && <Loading texto={loadingText} />}
          <Box sx={{ display: "flex", paddingLeft: 5 }}>
            {/* Aquí irán dos inputs la cual serán dos fechas de inicio y fin */}
            <Box sx={{ marginRight: 5 }}>
              <Calendar
                fecha={startDate?.fecha ? dayjs(startDate.fecha) : null}
                setFecha={setStartDate}
                label={"Desde el día"}
              />
            </Box>
            <Box sx={{ marginRight: 3 }}>
              <Calendar
                fecha={endDate?.fecha ? dayjs(endDate.fecha) : null}
                setFecha={setEndDate}
                label={"al día"}
              />
            </Box>
            {/* Botón para aplicar filtros */}
            <Button
              onClick={() => {
                setLoadingText("Obteniendo asistencias");
                getData();
              }}
            >
              Buscar
            </Button>
            <Typography
              id="transition-modal-title"
              variant="h4"
              color="primary"
              fontWeight={900}
              position={"absolute"}
              right={50}
            >
              ASISTENCIAS
            </Typography>
          </Box>
          <div style={{ width: "100%", padding: 20 }}>
            <DataGrid
              rows={rows}
              getRowId={(row) => row.ID}
              columns={columns}
              slots={{
                toolbar: GridToolbar,
              }}
            />
          </div>
        </div>
      </Fade>
      {/* Alerta de error */}
      <Snackbar
        open={showAlert}
        autoHideDuration={6000}
        onClose={() => setShowAlert(false)}
      >
        <Alert
          onClose={() => setShowAlert(false)}
          severity="error"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {errorAlert}
        </Alert>
      </Snackbar>
    </>
  );
};
